import { ChangeDetectionStrategy, Component } from '@angular/core';
import { JsonFormsAngularService, JsonFormsControl } from '@jsonforms/angular';
import { and, isStringControl, optionIs, RankedTester, rankWith } from '@jsonforms/core';

@Component({
  selector: 'AddressLookupControlRenderer',
  template: `
    <app-addressbox
      fxFlex
      [fxHide]="hidden"
      [readonly]="!isEnabled()"
      [fieldname]="getNameSetting()"
      [filterbyzipcode]="getZipCode()"
      fieldvalue="{{this.data}}"
      (suggestedaddress)="setAddressInputValues($event)"
    >
    </app-addressbox>
  `,
  changeDetection: ChangeDetectionStrategy.Default
})

export class AddressLookupControl extends JsonFormsControl {
  constructor(jsonformsService: JsonFormsAngularService) {
    super(jsonformsService);
  }

  getNameSetting = (): string => {
    return this.uischema?.options?.name ?? '';
  };

  getZipCode = (): string => {
    const zipcodeElement =
      this.uischema?.options?.smartyStreetInputs?.find((addressLine) => addressLine.field === 'zipcode')?.element ?? '';
    const zipcodeValue = (document.querySelectorAll(`*[id^="${zipcodeElement}"]`)[0] as HTMLInputElement)?.value ?? '';
    return zipcodeValue;
  };

  getEventValue = (event: any) => {
    return event.streetLine;
  };

  setAddressInputValues(addrObj) {
    this.onChange(addrObj);
    if (!addrObj.success) return;
    var addressFields = this.uischema?.options?.smartyStreetInputs ?? [];
    for (let addressField of addressFields) {
      var field = addressField.field;
      var element = addressField.element;

      var addressFieldValue = field in addrObj ? addrObj[field] : '';
      var domElement = document.querySelectorAll(`*[id^="${element}"]`)[0] as HTMLInputElement;
     
      var event = new Event('input', { bubbles: true });
      domElement.value = addressFieldValue;
      domElement.dispatchEvent(event);
    }
  }
}

export const AddressLookupRendererTester: RankedTester = rankWith(11, and(optionIs('format', 'address-lookup'), isStringControl));
